// import { SocketImplementation } from "./socket-implement";
import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';
// import { Http } from '@angular/http';
import { ToastController, ModalController, LoadingController, AlertController } from 'ionic-angular';
import { DIC } from './pages/dic';
import * as moment from 'moment';
// import { PaymentPage } from './pages/payment/payment';


import * as Excel from "exceljs/dist/exceljs.min.js";
import * as ExcelProper from "exceljs";
import saveAs from 'file-saver';
// import { Http } from '@angular/http';
import { Http, RequestOptions } from '@angular/http';
import { HTTP } from '@ionic-native/http'




@Injectable()


export class GN {

    locationhost = ''
    routeBankEditId = -1
    routeBankFunction: any
    isGPSLINK: boolean = false
    //reportSelectedVxehciles = []
    xlsFunction: any
    xlsFunctionToServer: boolean = false
    xlsFunctionCallback = null

    txtFunction: any

    rep_selectedVehiclesIds = [0]
    rep_selectedVehiclesText = ''
    toastConnection: any;
    isApp: boolean = false;
    userPlatform: string = ''
    isTablet: boolean = false
    notifInterval: any = null
    releaseInterval: any = null
    checkUserInterval: any = null
    myTime: any = new Date()
    myTimeStr: any
    routesChanges = []
    routesChangesPois = []
    routesChangesTest = []

    routesCh1 = []
    routesCh2 = []
    routesCh3 = []

    routesCh4 = []
    routesCh5 = []
    routesCh6 = []
    routesCh7 = []
    routesCh8 = []

    Notifications = []
    IndoorNotifications = []
    NlbTestNotifications = []
    NlbOtherNotifications = []
    ReleaseVersion = []
    NotificationsCount: number = 0
    NotificationsCount1: number = 0
    NotificationsSpeedCount: number = 0 //live speed warning

    NotificationsSpeed = []

    NlbTestNotificationsCount: number = 0
    NlbOtherNotificationsCount: number = 0
    IndoorNotificationsCount: number = 0
    testtf = false;
    notifTf = false
    loaderWaiting: any
    currentDT: any;
    currYear: number = 2000
    Vehicles = []
    VehiclesSortDt = []
    Markers = []
    VehicleAnim = []
    VehiclesDic = []
    Socket: any;
    userHASH: string = ''
    Organisations = []
    Beacons = []
    ConnMech = []
    BeaconConnMech = []
    AgrOperations = []
    Costs = []
    Articles = []
    mapPage: any
    centralnabaza = []
    allDevices = []
    allDevicesIds = []
    repfromlive = false;
    workoders = []
    allpinusers = []
    allprocess = []
    allarticles = []

    allpinusers2 = []
    allprocess2 = []
    allarticles2 = []

    resetPassUser = ''

    //LOGOUT - edit user - user deactivated or changed password
    logout = false;

    user = {
        UserId: -1,
        UserGroup: '',
        UserFullName: '',
        defaultmap: 'GOOGLE',
        idleover: 1,
        password: '',
        driverid: -1,
        ClientId: -1,
        ClientName: '',
        RoleId: -1,
        TimeZone: '',
        DateTimeFormat: '',
        Snooze: '',
        allowsmsvemail: '',
        cbdistance: "",
        cbfuel: "",
        cbrpm: "",
        cbtemp: "",
        datetimeformat: "d-m-Y H:i:s",
        fuel: "0",
        avgfuelunit: 'lit/100 Km',
        liquidunit: "litar",
        liquidvalue: 1,
        liquidstr: "lit",
        location: "1",
        metric: "Km",
        metric1: "meters",
        passengers: "1",
        poi: "1",
        speed: "1",
        taximeter: "1",
        tempunit: "C",
        tempunitstr: "°C",
        timedate: "1",
        weather: "1",
        zone: "1",
        DFormat: '',
        TFormat: '',
        metricspeed: 'Km/h',
        metriccurrency: 'MKD',
        metriccurrencyvalue: 1,
        metricvalue: 1,
        metricvalue1: 1,
        lastreleaseversion: '1',
        vehsize: 3,
        leftpanelsize: 3,
        username: '',
        email: ''

    }

    // liveoptions = {
    //     // userid:-1,
    //     //  clientid,
    //     dt: '1',
    //     alias: '1',
    //     driver: '1',
    //     destination: '1',
    //     roaddirection: '1',
    //     model: '1',
    //     rpm: '1',
    //     roomtemp: '1',
    //     ufuel: '1',
    //     fuel: '1',
    //     odometer: '1',
    //     jack: '1',
    //     battery: '1',
    //     inputvoltage: '1',
    //     pump: '1',
    //     cap: '1',
    //     codriver: '1',
    //     frontdoor: '1',
    //     reardoor: '1',
    //     enginecap: '1',
    //     fuelcap: '1',
    //     speed: '1',
    //     taximeter: '1',
    //     passеngers: '1',
    //     cbfuel: '1',
    //     cbrpm: '1',
    //     cbtemp: '1',
    //     cbdist: '1',
    //     loc: '1',
    //     poi: '1',
    //     zone: '1',
    // }
    liveoptions = []

    clientsettings = {
        logoimg: '',
        allowedfm: "0",
        allowedalarms: "0",
        allowedrouting: "0",
        alloweddrivershift: "0",
        clienttypeid: 2,
        allowdriverasuser: '0',
        '30days': 0,
        hasint: 0,
        hastow: 0,
        hasdrivers: 0,
        hassecurityprotocol: 0,
        hasallowfuelpulses: 0,
        hasallcan300: 0,
        haslvcan200: 0,
        hasfuelint: 0,
        hascbfuel: 0,
        hasbuzzer: 0,
        hasdraeger: 0,
        hastotalfuelused: 0,
        hastowveh: 0,
        hasdigalkaanalog: 0,
        showstayfuel: '0',
        travelorder: '0',
        allowedmess: '0',
        hasbluetoothtemp: 0,
        hasallowtacho: 0,
        hasallowgarmin: 0,
        hasewt: 0,
        stopstatusdata: [],
        hasallowbeacon: 0,
        haspersonbeacon: 0,
        hasassetbeacon: 0,
        tafomaintegration: '0',
        indoor: 0,
        hasvehshifts: '0',
        personalroutenumbering: '0',
        routeby: 'mapquest',
        citylon: 0,
        citylat: 0
    }
    vehdetails = {
        ddriver: "1",
        dtime: "1",
        dodometer: "1",
        dspeed: "1",
        dlocation: "1",
        dpoi: "1",
        dzone: "1",
        dntours: "1",
        dprice: "1",
        dtaximeter: "1",
        dpassengers: "1",
        dforecast: "1"
    }
    priv = []
    onlyactreportbyuid = []
    Colors = {
        engineon: '',
        engineoff: '',
        engineoffpassengeron: '',
        satelliteoff: '',
        taximeteron: '',
        taximeteroffpassengeron: '',
        passiveon: '',
        activeoff: ''
    }

    fullnameusers: any = [];
    loading: any;
    tfBtn: boolean = false;
    //isenabled: boolean = false;
    reloadCHatFunction: any = null
    reloadCHatFunction2: any = null

    ChatCount = 0
    ChatCountList = []
    PushToken = ''

    soundPlayer = new Audio('./assets/sound/probno.mp3');
    notificationOffset: number = 0
    notificationNlbTestOffset: number = 0
    notificationNlbOtherOffset: number = 0
    pinemployee = false;
    beaconprocess = false;
    pin = {
        pinid: -1,
        name: ''
    }
    indoorclientFlag = false
    indooruserid = -1

    globalreportButtons = false
    csvoption
    csvarray = []
    csvvisitedpoi = []
    globalPinEmployees = []
    alert
    alert2
    promptflag = false
    resetalert = 120 //60 ili 120
    timeralert

    vehallowshift = [] //KIKI
    companydays = [] //KIKI

    constructor(public httpWeb: Http, public http: HTTP, public toastCtrl: ToastController, public dic: DIC, public modalCtrl: ModalController, public loadingCtrl: LoadingController, public alertCtrl: AlertController) {
        this.currYear = (new Date()).getFullYear()

        //KIKI START
        // this.setVehAllowShifts()

        //KIKI END
    }

    //KIKI START
    setVehAllowShifts() {
        var _arr = []
        var _that = this
        this._Post('/api/gn/getvehicleshifts', { cid: this.crypt(this.user.ClientId) }, function (_data) {
            _arr = _data

            for (var i = 0; i < _arr.length; i++) {
                if (moment('1900-01-01 ' + _arr[i].timefrom) > moment('1900-01-01 ' + _arr[i].timeto)) {
                    _arr.push({ vehid: _arr[i].vehid, dow: (_arr[i].dow), timefrom: _arr[i].timefrom, timeto: '23:59:59' })
                    var _downext = _arr[i].dow + 1
                    if (_downext > 7) _downext = 1
                    _arr.push({ vehid: _arr[i].vehid, dow: _downext, timefrom: '00:00:00', timeto: _arr[i].timeto })
                    _arr.splice(i, 1)
                }
            }
            _that.vehallowshift = _arr

            _that._Post('/api/gn/getDaysOffAll', { cid: _that.crypt(_that.user.ClientId) }, function (_data) {
                _that.companydays = _data
                // var _res = _that.isholiday('2021-08-02')
                // alert('###' + _res)
            })
        })
    }
    isholiday(_dt) {
        return this.companydays.some(function (el) {
            return (el.datumymd + '' === _dt + '')
        });
    }
    checkDtVehAllowShift(_dt, _vehid) {
        if (this.clientsettings.hasvehshifts == '0') return true;
        var _time = moment(moment(_dt).format('1900-01-01 HH:mm:ss'))
        var _dow = !this.isholiday(moment(_dt).format('YYYY-MM-DD')) ? moment(_dt).day() : 8
        return this.vehallowshift.some(function (el) {
            return (el.dow === _dow && el.vehid === _vehid && (_time >= (moment('1900-01-01 ' + el.timefrom)) && _time <= (moment('1900-01-01 ' + el.timeto))))
        });
    }
    //KIKI END

    showConnectionToast() {
        if (this.toastConnection == null) {
            // this.toastConnection = this.toastCtrl.create({
            //     message: this.dic.l["lostconnn"],
            //     duration: 0, position: 'top'
            // });
            // this.toastConnection.present();
            this.toastConnection = this.loadingCtrl.create({
                content: this.dic.l["lostconnn"],
                duration: 0,
                cssClass: 'lostconnloading'
            });
            this.toastConnection.present();
        }
    }
    hideConnectionToast() {
        if (this.toastConnection != null) {
            this.toastConnection.dismiss()
            this.toastConnection = null
            let toastConnected = this.toastCtrl.create({
                message: this.dic.l["connectedtoast"],
                duration: 1500, position: 'bottom', cssClass: 'connectedtoast'
            });
            toastConnected.present();
        }
    }
    clearData() {
        this.stopIntervalForNotifications()
        this.stopIntervalForRelease()
        this.stopIntervalForCheckUser()
        localStorage.setItem("PANQAWSEDRF", "")
        localStorage.setItem("gn-asd-poi", this.oldcrypt('0'))
        localStorage.setItem("login-dt", 'null')
        this.Organisations = []
        this.Beacons = []
        this.allpinusers = []
        this.allprocess = []
        this.allarticles = []
        this.allpinusers2 = []
        this.allprocess2 = []
        this.allarticles2 = []
        this.resetPassUser = ''
        //LOGOUT - edit user - user deactivated or changed password
        this.logout = false;
        this.ConnMech = []
        this.BeaconConnMech = []
        this.AgrOperations = []
        this.Articles = []
        this.Vehicles = []
        this.VehiclesSortDt = []
        this.Markers = []
        this.VehicleAnim = []
        this.VehiclesDic = []
        this.Notifications = []
        this.NotificationsSpeed = []
        this.IndoorNotifications = []
        this.NlbTestNotifications = []
        this.NlbOtherNotifications = []
        this.ReleaseVersion = []
        this.NotificationsCount = 0
        this.NotificationsSpeedCount = 0
        this.IndoorNotificationsCount = 0
        this.NlbTestNotificationsCount = 0
        this.NlbOtherNotificationsCount = 0
        this.userHASH = ''
        this.user = {
            UserId: -1,
            UserGroup: '',
            UserFullName: '',
            defaultmap: 'GOOGLE',
            idleover: 1,
            password: '',
            driverid: -1,
            ClientId: -1,
            ClientName: '',
            RoleId: -1,
            TimeZone: '',
            DateTimeFormat: '',
            Snooze: '',
            allowsmsvemail: '',
            cbdistance: "",
            cbfuel: "",
            cbrpm: "",
            cbtemp: "",
            datetimeformat: "d-m-Y H:i:s",
            fuel: "0",
            avgfuelunit: 'lit/100 Km',
            liquidunit: "litar",
            liquidvalue: 1,
            liquidstr: "lit",
            location: "1",
            metric: "Km",
            metric1: "meters",
            passengers: "1",
            poi: "1",
            speed: "1",
            taximeter: "1",
            tempunit: "C",
            tempunitstr: "°C",
            timedate: "1",
            weather: "1",
            zone: "1",
            DFormat: '',
            TFormat: '',
            metricspeed: 'Km/h',
            metriccurrency: 'MKD',
            metriccurrencyvalue: 1,
            metricvalue: 1,
            metricvalue1: 1,
            lastreleaseversion: '1',
            vehsize: 3,
            leftpanelsize: 3,
            username: '',
            email: ''
        }
        this.vehallowshift = []
        // this.liveoptions = []


        // this.liveoptions = {
        //     // userid:-1,
        //     //  clientid,
        //     dt: '1',
        //     alias: '1',
        //     driver: '1',
        //     destination: '1',
        //     roaddirection: '1',
        //     model: '1',
        //     rpm: '1',
        //     roomtemp: '1',
        //     ufuel: '1',
        //     fuel: '1',
        //     odometer: '1',
        //     jack: '1',
        //     battery: '1',
        //     inputvoltage: '1',
        //     pump: '1',
        //     cap: '1',
        //     codriver: '1',
        //     frontdoor: '1',
        //     reardoor: '1',
        //     enginecap: '1',
        //     fuelcap: '1',
        //     speed: '1',
        //     taximeter: '1',
        //     passеngers: '1',
        //     cbfuel: '1',
        //     cbrpm: '1',
        //     cbtemp: '1',
        //     cbdist: '1',
        //     loc: '1',
        //     poi: '1',
        //     zone: '1',
        // }

        this.clientsettings = {
            logoimg: '',
            allowedfm: "0",
            allowedalarms: "0",
            allowedrouting: "0",
            alloweddrivershift: "0",
            clienttypeid: 2,
            allowdriverasuser: '0',
            '30days': 0,
            hasint: 0,
            hastow: 0,
            hasdrivers: 0,
            hassecurityprotocol: 0,
            hasallowfuelpulses: 0,
            hasallcan300: 0,
            haslvcan200: 0,
            hasfuelint: 0,
            hascbfuel: 0,
            hasbuzzer: 0,
            hasdraeger: 0,
            hastotalfuelused: 0,
            hastowveh: 0,
            hasdigalkaanalog: 0,
            showstayfuel: '0',
            travelorder: '0',
            allowedmess: '0',
            hasbluetoothtemp: 0,
            hasallowtacho: 0,
            hasallowgarmin: 0,
            hasewt: 0,
            stopstatusdata: [],
            hasallowbeacon: 0,
            haspersonbeacon: 0,
            hasassetbeacon: 0,
            tafomaintegration: '0',
            indoor: 0,
            hasvehshifts: '0',
            personalroutenumbering: '0',
            routeby: 'mapquest',
            citylon: 0,
            citylat: 0
        }
        this.vehdetails = {
            ddriver: "1",
            dtime: "1",
            dodometer: "1",
            dspeed: "1",
            dlocation: "1",
            dpoi: "1",
            dzone: "1",
            dntours: "1",
            dprice: "1",
            dtaximeter: "1",
            dpassengers: "1",
            dforecast: "1"
        }
        this.priv = []
        this.onlyactreportbyuid = []
        this.Colors = {
            engineon: '',
            engineoff: '',
            engineoffpassengeron: '',
            satelliteoff: '',
            taximeteron: '',
            taximeteroffpassengeron: '',
            passiveon: '',
            activeoff: ''
        }
        this.Vehicles = []
        this.VehiclesSortDt = []
        this.tfBtn = false;
        this.pinemployee = false;
        this.beaconprocess = false;
        this.indoorclientFlag = false
        this.globalPinEmployees = []

        //this.isenabled = false
    }
    public fInt(_num: any) {
        var a = parseInt(_num)
        var ret = a.toFixed(0).replace(/./g, function (c, i, a) { return i && c !== "." && ((a.length - i) % 3 === 0) ? ' ' + c : c; });
        return ret
    }
    public fFloat(_num: any) {
        return parseFloat(_num).toFixed(2).replace(/./g, function (c, i, a) { return i && c !== "." && ((a.length - i) % 3 === 0) ? ',' + c : c; });
    }

    public cr(_text: any) {
        if (_text == null) { _text = '' }
        if (_text == undefined) { _text = '' }
        let key = "a5ed56c81dMotherFuckerMyDelBoy2202983440001SanamaGun3290020";
        let enID = CryptoJS.AES.encrypt(_text + '', key).toString();
        return enID
    }

    public dc(_text: any) {
        if (_text == null) { _text = '' }
        if (_text == undefined) { _text = '' }
        let key = "a5ed56c81dMotherFuckerMyDelBoy2202983440001SanamaGun3290020";
        let enID = CryptoJS.AES.decrypt(_text, key).toString(CryptoJS.enc.Utf8);
        return enID
    }

    public crypt(_text: any) {
        _text = _text + ''
        _text = _text.replace(/\'/g, "''")
        // _text = _text.replace(/\"/g, "")

        var txt = this.cr(_text)
        txt = this.cr(txt)
        return txt
    }
    public decrypt(_text: any) {
        var txt = this.dc(_text)
        txt = this.dc(txt)
        return txt
    }

    public oldcrypt(_text) {
        _text = _text + ''
        var carr = ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J"]
        var _ret = ''

        for (var i = 0; i < _text.length; i++) {

            var _asc = _text[i].charCodeAt()
            _asc = _asc ^ 22
            var _asc2 = _asc + ''
            while (_asc2.length < 7) { _asc2 = '0' + _asc2 }
            _ret = _ret + _asc2
        }
        var _ret2 = ''
        for (var i = 0; i < _ret.length; i++) {
            _ret2 = _ret2 + carr[parseInt(_ret[i])]
        }
        return _ret2
    }

    public rnd() { return Math.floor(Math.random() * 1e6).toString(); }
    public rndCode() {
        return Math.floor(Math.random() * (999999 - 100000 + 1) + 100000);
    }
    public _Get(_url: any, _data: any, _callback: any) {
        console.log("------- this.isApp -----", this.isApp)
        var _that = this
        if (this.isApp == true) {
            if (_url.indexOf('https://panorama.gps.mk') == -1) {
                _url = 'https://panorama.gps.mk' + _url
            };
            // console.log(this.isApp,_url)
            this.http.get(_url, _data, {}).then(data => {
                var _data = JSON.parse(data.data)
                if (_callback != null) {
                    _callback(_data)
                }
            }).catch(err => {
                if (err.status + '' == '500' || err.status + '' == '404') {
                    setTimeout(function () {
                        _that._Get(_url, _data, _callback)
                    }, 1000)
                }
                // console.log(err)
            });
        } else {
            this.httpWeb.get(_url, _data).subscribe(function (data: any) {
                var _data = JSON.parse(data._body)
                if (_callback != null) {
                    _callback(_data)
                }
            }, function (err) {
                // console.log(err)
            });
        }

    }

    /** Historical odometer in kilometres (API units), independent of form state. */
    public getCurrkmByDate(date: string, vehicleid: string | number): Promise<number | null> {
        const parsedDate = moment(date, 'YYYY-MM-DD', true);
        if (!parsedDate.isValid() || vehicleid == null || String(vehicleid).trim() === '') {
            return Promise.reject(new Error('Недостасува валиден датум или ID на возило.'));
        }
        const payload = {
            d: this.crypt(parsedDate.format('YYYY-MM-DD')),
            vehid: this.crypt(String(vehicleid))
        };
        return new Promise<number | null>((resolve, reject) => {
            let subscription: any;
            let finished = false;
            const finish = (error: Error, response?: any) => {
                if (finished) { return; }
                finished = true;
                clearTimeout(timer);
                if (subscription) { subscription.unsubscribe(); }
                if (error) { reject(error); return; }
                try {
                    const data = typeof response === 'string' ? JSON.parse(response) : response;
                    const value = data == null ? null : data.odometer;
                    if (value == null || (typeof value === 'string' && value.trim() === '')) {
                        resolve(null);
                    } else if ((typeof value === 'number' || typeof value === 'string') &&
                        isFinite(Number(value)) && Number(value) >= 0) {
                        resolve(Number(value));
                    } else {
                        reject(new Error('Серверот врати невалидна километража.'));
                    }
                } catch (err) {
                    reject(new Error('Одговорот за километражата не може да се прочита.'));
                }
            };
            const timer = setTimeout(() => finish(new Error('Истече времето за вчитување на километражата.')), 15000);
            try {
                if (this.isApp) {
                    this.http.post('https://panorama.gps.mk/api/gn/getcurrkm', payload, {})
                        .then(response => finish(null, response.data))
                        .catch(() => finish(new Error('Километражата не може да се вчита.')));
                } else {
                    subscription = this.httpWeb.post('/api/gn/getcurrkm', payload).subscribe(
                        response => finish(null, response.text()),
                        () => finish(new Error('Километражата не може да се вчита.'))
                    );
                }
            } catch (err) {
                finish(new Error('Километражата не може да се вчита.'));
            }
        });
    }

    public _Post(_url: any, _data: any, _callback: any, _attemp: number = 1,
        options: { retry?: boolean; onError?: (error: any) => void } = {}) {
        // console.log("------- this.isApp -----", this.isApp)
        var _that = this
        if (this.isApp == true) {
            if (_url.indexOf('https://panorama.gps.mk') == -1 && _url.indexOf('www.googleapis.com') == -1) {
                _url = 'https://panorama.gps.mk' + _url
            };
            this.http.post(_url, _data, {}).then(function (data: any) {
                var _data = JSON.parse(data.data)
                if (_callback != null) {
                    _callback(_data)
                }
            }).catch(err => {
                if (options.retry === false) {
                    if (options.onError) { options.onError(err); }
                    return;
                }
                if (err.status + '' == '500') {
                    setTimeout(function () {
                        _that._Post(_url, _data, _callback, 1, options)
                    }, 1000)
                }
            });
        } else {
            this.httpWeb.post(_url, _data).subscribe(function (data: any) {
                let response: any;
                try {
                    response = JSON.parse(data._body);
                } catch (error) {
                    if (options.onError) { options.onError(error); return; }
                    throw error;
                }
                if (_callback != null) {
                    _callback(response)
                }
            }, function (err) {
                if (options.retry === false) {
                    if (options.onError) { options.onError(err); }
                    return;
                }
                // console.log(err)
                if (_attemp < 5) {
                    setTimeout(function () {
                        _that._Post(_url, _data, _callback, _attemp + 1, options)
                    }, 500)
                } else {
                    _that.showConnectionToast()
                }

            });
        }



        // var _that = this

    }

    public _PostHTML(_url: any, _data: any, _callback: any, _attemp: number = 1) {
        var _that = this
        this.httpWeb.post(_url, _data).subscribe(function (data: any) {
            var _data = _that.b64DecodeUnicode(data._body)
            if (_callback != null) {
                _callback(_data)
            }
        }, function (err) {
            // console.log(err)
            if (_attemp < 5) {
                setTimeout(function () {
                    _that._Post(_url, _data, _callback, _attemp + 1)
                }, 500)
            } else {
                _that.showConnectionToast()
            }

        });
    }

    public addLog(_idevent, _desc = '') {
        var _userAgent = navigator.userAgent.toLowerCase();
        var _ip = window["tfmIP"];

        this._Post('/api/gn/addLog', { uid: this.crypt(this.user.UserId), useragent: _userAgent, idevent: this.crypt(_idevent), desc: this.crypt(_desc), ip: this.crypt(_ip) }, function (_data) {
            console.log(_data.msg)
            //navigator.userAgent
            //debugger;
        })
    }

    public getVehiclesLog(vid) {
        var logvozilaarr = [];
        for (var i = 0; i < vid.length; i++) {
            for (var j = 0; j < this.Vehicles.length; j++) {
                if (vid[i] == this.Vehicles[j].vehicleid)
                    logvozilaarr.push('"' + this.Vehicles[j].registration + ' (' + this.Vehicles[j].code + ')"')
            }
        }

        return logvozilaarr.join(', ')
    }

    b64DecodeUnicode(str) {
        // Going backwards: from bytestream, to percent-encoding, to original string.
        return decodeURIComponent(atob(str).split('').map(function (c) {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        }).join(''));
    }

    isNumeric(n) {
        return !isNaN(parseFloat(n)) && isFinite(n);
    }


    cryptOld(_text) {
        _text = _text + ''
        var carr = ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J"]
        var _ret = ''

        for (var i = 0; i < _text.length; i++) {

            var _asc = _text[i].charCodeAt()
            _asc = _asc ^ 22
            var _asc2 = _asc + ''
            while (_asc2.length < 7) { _asc2 = '0' + _asc2 }
            _ret = _ret + _asc2
        }
        var _ret2 = ''
        for (var i = 0; i < _ret.length; i++) {
            _ret2 = _ret2 + carr[parseInt(_ret[i])]
        }
        return _ret2
    }

    setCookie(cname, cvalue, exdays) {
        var d = new Date();
        d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
        var expires = "expires=" + d.toUTCString();
        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    }

    getCookie(cname) {
        var name = cname + "=";
        var ca = document.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    }


    showPromptForPrivacy(_cb) {
        _cb()
        return
        // var tmp = localStorage.getItem("PanoramaPPAndroidABC")
        // if (tmp==null){tmp=''}
        // if (tmp=='YES'){
        //     _cb(true)
        //     return 
        // }
        // var _msg = `
        //     Panorama collects your device ID and transmits it to a third-party platform (OneSignal.com) to enable Push Notification for normal operation.
        // `
        // this.alert = this.alertCtrl.create({
        //     title: "Disclosure !",
        //     message: _msg,            
        //     buttons: [
        //         {
        //             text: 'Decline',
        //             handler: data => {
        //                 _cb(false)
        //             }
        //         },
        //         {
        //             text: "Agree",
        //             handler: data => { 
        //                 localStorage.setItem("PanoramaPPAndroidABC", "YES")
        //                 _cb(true)
        //             }
        //         }
        //     ],
        //     enableBackdropDismiss: false
        // });
        // this.alert.present();
    }

    showPrompt(array) {

        var obj = array
        var contain = false
        var _that = this
        this.alert = this.alertCtrl.create({
            title: _that.dic.l['login'],
            message: _that.dic.l["enteryourpin"],
            inputs: [
                {
                    name: _that.dic.l['Pin'],
                    placeholder: _that.dic.l['Pin']
                },
            ],
            buttons: [
                // {
                //     text: 'Cancel',
                //     handler: data => {
                //         console.log('Cancel clicked');
                //     }
                // },
                {
                    text: _that.dic.l['ok'],
                    handler: data => {
                        for (let i = 0; i < obj.length; i++) {
                            if (data.Пин + '' == obj[i].pinnumber1 + '' || data.Pin + '' == obj[i].pinnumber1 + '') {
                                contain = true
                                _that.pin.name = obj[i].fullname
                                _that.pin.pinid = obj[i].id
                                break
                            }
                        }
                        if (contain == false) {
                            _that.showPrompt(obj)
                        }
                        // if (contain == false) {
                        //     return
                        // }
                        // debugger
                        console.log('Saved clicked');
                    }
                }
            ],
            enableBackdropDismiss: false
        });
        this.alert.present();
    }

    public checkUserHash(_callback) {
        //userHASH
        this.locationhost = location.host;

        var _that = this
        var h = localStorage.getItem("PANQAWSEDRF")
        if (h == null && h == undefined) { h = '' }

        if (h != "") {
            this.userHASH = this.decrypt(h)
        }
        if (this.userHASH == '') { this.userHASH = '-1' }
        // if (!isNumber(this.userHASH)){
        //     this.userHASH = '-1'
        // }
        //25.47
        console.log('Complex Data A = ' + new Date().toISOString())
        this._Post('/api/gn/checkuser', { D1: this.crypt(this.userHASH) }, function (_data) {
            console.log('Complex Data B = ' + new Date().toISOString())
            if (_data.E1 > 0) {
                console.log('Complex Data Start = ' + new Date().toISOString())
                _that._Post('/api/gn/getuser', { D1: h }, function (_data) {
                    console.log('Complex Data Finish = ' + new Date().toISOString())
                    if (_data.pinemp.length > 0) {
                        _that.pinemployee = true
                        _that.globalPinEmployees = _data.pinemp
                        _that.showPrompt(_data.pinemp)
                    }

                    if (_data.beaconprocess.length > 0) {
                        _that.beaconprocess = true
                    }

                    if (_data.indooruser.length > 0) {
                        _that.indoorclientFlag = true
                        _that.indooruserid = _data.indooruser[0].id
                    }

                    // console.log(_data, 'daj da vidam datum')
                    _that.clientsettings = _data.clientsettings[0]
                    _that.vehdetails = _data.vdet[0]
                    _that.priv = _data.priv;
                    _that.onlyactreportbyuid = _data.onlyactreportbyuid;

                    for (var i = 0; i < _data.priv.length; i++) {
                        var idx = 0;

                        for (var key in _data.priv[i]) {
                            if (idx > 1) {
                                if (_data.priv[i][key] == '1')
                                    _that.priv[i][key] = true
                                else
                                    _that.priv[i][key] = false
                            }
                            idx++;
                        }
                    }
                    //console.log("**** USER SETTINGS ****")
                    //console.log(_data.user)

                    // console.log("**** CLIENT SETTINGS ****")
                    // console.log(_that.clientsettings)

                    // gn.db.write('gn-asd-poi', gn.UserId)
                    window.localStorage.setItem('gn-asd-poi', _that.oldcrypt(_data.user[0].id))
                    window.localStorage.setItem('user-pass', _that.oldcrypt(_data.user[0].password))
                    //window.localStorage.setItem('user-pass', _data.user[0].password)
                    _that.user.UserId = _data.user[0].id
                    _that.user.UserGroup = _data.user[0].organisationid
                    _that.user.UserFullName = _data.user[0].fullname
                    _that.user.defaultmap = _data.user[0].defaultmap
                    _that.user.idleover = _data.user[0].idleover
                    _that.user.password = _that.crypt(_data.user[0].password)
                    _that.user.driverid = _data.user[0].driverid
                    _that.user.ClientId = _data.user[0].clientid
                    _that.user.ClientName = _data.user[0].companyname
                    if ((_that.user.UserId) + '' == '3689') { //Геонет Тест
                        _that.user.ClientName = 'Geonet Agro Demo'
                    }
                    _that.user.RoleId = _data.user[0].roleid
                    _that.user.TimeZone = _data.user[0].tzone
                    _that.user.DateTimeFormat = _data.user[0].datetimeformat
                    _that.user.Snooze = _data.user[0].snooze
                    _that.user.allowsmsvemail = _data.user[0].allowsmsvemail
                    // _that.user.Monday = _data.user[0].snooze

                    _that.user.cbdistance = _data.usersettings[0].cbdistance
                    _that.user.cbfuel = _data.usersettings[0].cbfuel
                    _that.user.cbrpm = _data.usersettings[0].cbrpm
                    _that.user.cbtemp = _data.usersettings[0].cbtemp
                    _that.user.datetimeformat = _data.usersettings[0].datetimeformat
                    _that.user.fuel = _data.usersettings[0].fuel
                    _that.user.liquidunit = _data.usersettings[0].liquidunit
                    _that.user.location = _data.usersettings[0].location
                    _that.user.metric = _data.usersettings[0].metric
                    _that.user.metriccurrency = _data.usersettings[0].currency
                    _that.user.metriccurrencyvalue = _data.currency[0].value
                    _that.user.passengers = _data.usersettings[0].passengers
                    _that.user.poi = _data.usersettings[0].poi
                    _that.user.speed = _data.usersettings[0].speed
                    _that.user.taximeter = _data.usersettings[0].taximeter
                    _that.user.tempunit = _data.usersettings[0].tempunit
                    _that.user.tempunitstr = "°" + _data.usersettings[0].tempunit
                    _that.user.timedate = _data.usersettings[0].timedate
                    _that.user.weather = _data.usersettings[0].weather
                    _that.user.zone = _data.usersettings[0].zone
                    _that.user.lastreleaseversion = _data.usersettings[0].lastreleaseversion
                    _that.user.vehsize = _data.usersettings[0].vehsize
                    _that.user.username = _data.usersettings[0].username
                    _that.user.email = _data.usersettings[0].email

                    for (let i = 0; i < _data.liveoptions.length; i++) {
                        _data.liveoptions[i].bitone = parseInt(_data.liveoptions[i].bitone)
                    }
                    _that.liveoptions = _data.liveoptions

                    // debugger

                    if (_that.user.metric.toLowerCase() == 'km') {
                        _that.user.metricvalue = 1;
                        _that.user.metricvalue1 = 1;
                        _that.user.metricspeed = 'Km/h'
                        _that.user.metric1 = _that.dic.l['meters'];
                    }
                    else {
                        _that.user.metricvalue = 0.621371;
                        _that.user.metricvalue1 = 1.0936;
                        _that.user.metricspeed = 'mph'
                        _that.user.metric1 = 'yards';
                    }


                    if (_that.user.liquidunit.toLowerCase() == 'litar') {
                        _that.user.liquidvalue = 1;
                        _that.user.liquidstr = 'lit'
                    }
                    else {
                        _that.user.liquidvalue = 0.264172;
                        _that.user.liquidstr = 'gal'
                    }

                    if (_that.user.liquidunit.toLowerCase() == 'galon' && _that.user.metric == 'mi') {
                        _that.user.avgfuelunit = 'mpg';
                    }
                    else {
                        _that.user.avgfuelunit = _that.user.liquidstr + '/100 ' + _that.user.metric;
                    }

                    _that.Organisations = _data.org
                    //d-m-Y H:i:s
                    // console.log(_that.Organisations)
                    var _tmp = _that.user.datetimeformat.split(' ')
                    var DF = _tmp[0]
                    var TF = _tmp[1]
                    DF = DF.replace('d', 'DD')
                    DF = DF.replace('m', 'MM')
                    DF = DF.replace('Y', 'YYYY')

                    TF = TF.replace('H', 'HH')
                    TF = TF.replace('h', 'h')
                    TF = TF.replace('i', 'mm')
                    TF = TF.replace('s', 'ss')
                    if (_tmp.length == 3) {
                        TF = TF + ' ' + _tmp[2]
                    }
                    _that.user.DFormat = DF
                    _that.user.TFormat = TF
                    // console.log(_that.user)
                    //var DateFormat = 

                    _that.Colors = _data.colors[0]

                    if (_that.clientsettings.clienttypeid + '' == '18') {
                        _that._Post('/api/gn/getcentralnabaza', { cid: _that.crypt(_that.user.ClientId) }, function (_data) {
                            _that.centralnabaza = [{ id: _data[0].id, name: _data[0].name, lon: _data[0].lon, lat: _data[0].lat }]
                        })
                    }

                    if (_that.clientsettings.indoor > 0 || parseInt(_that.clientsettings.haspersonbeacon + '') > 0 || parseInt(_that.clientsettings.hasassetbeacon + '') > 0) {
                        _that._Post('/api/gn/getallbeacons', { cid: _that.crypt(_that.user.ClientId) }, function (_data) {
                            _that.Beacons = _data
                        })
                        _that._Post('/api/gn/getAllUsersPinIndoor', { cid: _that.crypt(_that.user.ClientId) }, function (_data) {
                            _that.allpinusers = _data
                            _that.allpinusers2 = _data

                        })
                        _that._Post('/api/gn/getAllProcessIndoor', { cid: _that.crypt(_that.user.ClientId) }, function (_data) {
                            _that.allprocess = _data
                            _that.allprocess2 = _data
                        })
                        // _that._Post('/api/gn/getcolutures', { cid: _that.crypt(_that.user.ClientId), indoor: _that.crypt(_that.clientsettings.indoor) }, function (_data) {
                        //     _that.allarticles = _data.A
                        // })
                        _that._Post('/api/gn/getAllArticlesIndoor', { cid: _that.crypt(_that.user.ClientId) }, function (_data) {
                            _that.allarticles = _data
                            _that.allarticles2 = _data

                        })
                    }
                    //zk pelagonija
                    if (_that.user.ClientId + '' == '367' || _that.user.ClientId + '' == '798') {
                        _that._Post('/api/gn/getcolutures', { cid: _that.crypt(_that.user.ClientId), indoor: _that.crypt(_that.clientsettings.indoor) }, function (_data) {
                            _that.ConnMech = _data.D
                        })
                        _that._Post('/api/gn/getallbeaconscultures', { cid: _that.crypt(_that.user.ClientId) }, function (_data) {
                            _that.BeaconConnMech = _data
                        })
                        _that._Post('/api/gn/getalloperations', { cid: _that.crypt(_that.user.ClientId) }, function (_data) {
                            _that.AgrOperations = _data
                        })
                    }
                    _that._Post('/api/gn/getallcosts', { cid: _that.crypt(_that.user.ClientId) }, function (_data) {
                        for (var a = 0; a < _data.length; a++) {
                            if (_data[a].name == 'fuel') _data[a].name = _that.dic.l["Fuel"]
                            if (_data[a].name == 'service') _data[a].name = _that.dic.l["service"]
                            if (_data[a].name == 'othercosts') _data[a].name = _that.dic.l["iznothcosts"]
                        }
                        _that.Costs = _data
                    })
                    //indoor asset
                    if (_that.clientsettings.indoor == 2) {
                        _that._Post('/api/gn/getcolutures', { cid: _that.crypt(_that.user.ClientId), indoor: _that.crypt(_that.clientsettings.indoor) }, function (_data) {
                            _that.ConnMech = _data.D
                            _that.Articles = _data.A
                        })
                        _that._Post('/api/gn/getallbeaconscultures', { cid: _that.crypt(_that.user.ClientId) }, function (_data) {
                            _that.BeaconConnMech = _data
                        })
                    }

                    //KIKI START
                    _that.setVehAllowShifts()
                    //KIKI END
                    _callback()
                })
            } else {
                _callback()
            }
        })
    }

    formatDT(_datum, withTZ: boolean = false) {

        if (withTZ == false) {

        } else {
            //moment().format(gn.user.TFormat)
        }
    }
    public impulseUsers(_usersIds, _key, _params) {
        // _usersIds = _usersIds + ''
        // var usr = _usersIds.split(',')
        // for (var i = 0; i < usr.length; i++) {
        //     this.Socket.emit({ uid: usr[i], key: _key, param: _params }, function (_data) { }, 'impulse')
        // }
    }


    getChatCounts() {
        // console.log('getchatcount')
        var _that = this
        this._Post('/api/gn/getchatcount', { id: this.crypt(this.user.UserId) }, function (_data) {
            _that.ChatCountList = _data
            _that.ChatCount = _data.length
            if (_that.reloadCHatFunction2 != null) {
                _that.reloadCHatFunction2()
            }
        })
    }

    onImpulse(_data) {
        var _that = this
        console.log('*** IMPULSE', _data)
        var _interval = _data.interval
        var _params = _data.param
        var _key = _data.key
        if (_data.key == 'newchat') {
            _that.getChatCounts()
            if (_that.reloadCHatFunction != null) {
                if (_params.toid + '' == this.user.UserId + '') {
                    setTimeout(function () {
                        _that.reloadCHatFunction()
                        // _that.reloadCHatFunction2()                        
                    }, _interval)
                }
            }
            console.log(_params)
            // setTimeout(function () {
            //     _that.services.loadNotifications()
            //     _that.NotificationCount = _params.cnt

            // }, _data.interval)
        }
    }
    startIntervalForNotifications() {
        this.getNotifications()
        if (this.clientsettings.indoor > 0) {
            this.getIndoorProtocolAlerts()
        }

        var _that = this
        if (this.notifInterval == null) {
            this.notifInterval = setInterval(function () {
                _that.getNotifications()

                _that.getChatCounts()

                if (_that.clientsettings.indoor > 0) {
                    _that.getIndoorProtocolAlerts()
                }
            }, 1 * 60 * 1000)
        }
    }

    startIntervalForCheckUser() {
        var _that = this
        if (this.checkUserInterval == null) {
            this.checkUserInterval = setInterval(function () {
                if (localStorage.getItem("UPDATE-PANPASS") == null) {
                    //ODLOGIRAJ
                    //console.log('#1 ODLOGIRAJ');
                    _that.do_logout();
                } else {
                    var _duration = moment.duration(moment().diff(moment(localStorage.getItem("CHECK-PANPASS"))));
                    //console.log('now: ' + moment().format('YYYY-MM-DD HH:mm:ss') + ' check: ' + localStorage.getItem("CHECK-PANPASS") + ' lastupdate: ' + localStorage.getItem("UPDATE-PANPASS"))
                    var _minutes = _duration.asMinutes();
                    //console.log(_minutes)
                    if (_minutes > 1) {
                        _that._Post('/api/gn/getLastUpdatePass', { uid: _that.crypt(_that.user.UserId) }, function (_dataL) {
                            //console.log('getLastUpdatePass ' + moment(_dataL.L).format('YYYY-MM-DD HH:mm:ss'))
                            localStorage.setItem("UPDATE-PANPASS", moment(_dataL.L).format('YYYY-MM-DD HH:mm:ss'))

                            if (_dataL.A + '' == '0') {
                                //ODLOGIRAJ
                                //console.log('#2 ODLOGIRAJ')
                                _that.do_logout();
                            } else {
                                //console.log(moment(localStorage.getItem("UPDATE-PANPASS")).format('YYYY-MM-DD HH:mm:ss') + ' ' + moment(localStorage.getItem("CHECK-PANPASS")).format('YYYY-MM-DD HH:mm:ss'))
                                if (moment(localStorage.getItem("UPDATE-PANPASS")) > moment(localStorage.getItem("CHECK-PANPASS"))) {
                                    //ODLOGIRAJ
                                    //console.log('#3 ODLOGIRAJ')
                                    _that.do_logout();
                                } else {
                                    localStorage.setItem("CHECK-PANPASS", moment().format('YYYY-MM-DD HH:mm:ss'))
                                }
                            }
                        })
                        //napravi nesto proveri - земи го lastupdatepass ako e ponov od CHECK-PANPASS-5min odlogiraj
                        // _that.checkUserHash(function () {

                        // });
                    }
                }
            }, 10 * 1000)
        }
    }

    startIntervalForRelease() {
        this.getReleaseVersion()
        var _that = this
        if (this.releaseInterval == null) {
            this.releaseInterval = setInterval(function () {
                _that.getReleaseVersion()
            }, 10 * 60 * 1000)
        }
    }
    getIndoorProtocolAlerts() {
        var _that = this
        var tmpCntIndoorAlarms = _that.IndoorNotificationsCount;

        var notificationLimit = _that.notificationOffset + 10
        _that._Post('/api/gn/getIndoorProtocolAlerts', { cid: _that.crypt(_that.user.ClientId), uid: _that.crypt(_that.user.UserId), limit: _that.crypt(notificationLimit), offset: _that.crypt(0) }, function (_data) {
            _that.IndoorNotifications = _data.data
            _that.IndoorNotificationsCount = _data.cnt

            if (_that.IndoorNotificationsCount > 0 && _that.IndoorNotificationsCount > tmpCntIndoorAlarms) {
                _that.soundPlayer.play();
            }


            // _that._Post('/api/gn/getnotificationsalarms', { cid: _that.crypt(_that.user.ClientId), rid: _that.crypt(_that.user.RoleId), uid: _that.crypt(_that.user.UserId), limit: _that.crypt(notificationLimit), offset: _that.crypt(0) }, function (_data) {
            //     _that.Notifications = _data
            for (let i = 0; i < _that.IndoorNotifications.length; i++) {
                _that.IndoorNotifications[i].date = moment(_that.IndoorNotifications[i].datetime).format('DD') + ' ' + _that.dic.l[moment(_that.IndoorNotifications[i].datetime).format('MMMM')] + ' ' + moment(_that.IndoorNotifications[i].datetime).format('YYYY');
                _that.IndoorNotifications[i].time = moment(_that.IndoorNotifications[i].datetime).format(_that.user.TFormat);

                if (_that.IndoorNotifications[i].name == 'draeger') {
                    _that.IndoorNotifications[i].date1 = moment(_that.IndoorNotifications[i].info.split('^^^')[0]).format('DD') + ' ' + _that.dic.l[moment(_that.IndoorNotifications[i].info.split('^^^')[0]).format('MMMM')] + ' ' + moment(_that.IndoorNotifications[i].info.split('^^^')[0]).format('YYYY');
                    _that.IndoorNotifications[i].time1 = moment(_that.IndoorNotifications[i].info.split('^^^')[0]).format(_that.user.TFormat);

                    _that.IndoorNotifications[i].avalue = _that.IndoorNotifications[i].info.split('^^^')[1]
                    _that.IndoorNotifications[i].avalueDraegerDriver = _that.IndoorNotifications[i].info.split('^^^')[2]
                }
            }
            // })

        })
    }
    getNotifications() {
        var _that = this

        //nlb - realni i test alarmi
        if (this.clientsettings.clienttypeid + '' == '18') {
            var tmpCntTestAlarms = _that.NlbTestNotificationsCount;
            var tmpCntOtherAlarms = _that.NlbOtherNotificationsCount;

            //test
            _that._Post('/api/gn/getnotifications', { type: _that.crypt('test'), cid: _that.crypt(_that.user.ClientId), rid: _that.crypt(_that.user.RoleId), uid: _that.crypt(_that.user.UserId) }, function (_data) {
                var _cnt = 0
                for (var i = 0; i < _data.length; i++) {
                    _cnt = _cnt + parseInt(_data[i].cnt)
                }
                _that.NlbTestNotificationsCount = _cnt

                if (_that.user.driverid + '' == '-1' && _that.NlbTestNotificationsCount > 0 && _that.NlbTestNotificationsCount > tmpCntTestAlarms) {
                    _that.soundPlayer.play();
                }
                var notificationLimit = _that.notificationNlbTestOffset + 10

                _that._Post('/api/gn/getnotificationsalarms', { type: _that.crypt('test'), cid: _that.crypt(_that.user.ClientId), rid: _that.crypt(_that.user.RoleId), uid: _that.crypt(_that.user.UserId), limit: _that.crypt(notificationLimit), offset: _that.crypt(0) }, function (_data) {
                    _that.NlbTestNotifications = _data
                    for (let i = 0; i < _that.NlbTestNotifications.length; i++) {
                        _that.NlbTestNotifications[i].date = moment(_that.NlbTestNotifications[i].datetime).format('DD') + ' ' + _that.dic.l[moment(_that.NlbTestNotifications[i].datetime).format('MMMM')] + ' ' + moment(_that.NlbTestNotifications[i].datetime).format('YYYY');
                        _that.NlbTestNotifications[i].time = moment(_that.NlbTestNotifications[i].datetime).format(_that.user.TFormat);

                        if (_that.NlbTestNotifications[i].name == 'draeger') {
                            _that.NlbTestNotifications[i].date1 = moment(_that.NlbTestNotifications[i].info.split('^^^')[0]).format('DD') + ' ' + _that.dic.l[moment(_that.NlbTestNotifications[i].info.split('^^^')[0]).format('MMMM')] + ' ' + moment(_that.NlbTestNotifications[i].info.split('^^^')[0]).format('YYYY');
                            _that.NlbTestNotifications[i].time1 = moment(_that.NlbTestNotifications[i].info.split('^^^')[0]).format(_that.user.TFormat);

                            _that.NlbTestNotifications[i].avalue = _that.NlbTestNotifications[i].info.split('^^^')[1]
                            _that.NlbTestNotifications[i].avalueDraegerDriver = _that.NlbTestNotifications[i].info.split('^^^')[2]
                        }
                    }
                })

                //LIVE SPEED WARNING
                _that._Post('/api/gn/getspeednotifications', { cid: _that.crypt(_that.user.ClientId), rid: _that.crypt(_that.user.RoleId), uid: _that.crypt(_that.user.UserId) }, function (_data) {
                    var _cntS = 0
                    for (var i = 0; i < _data.length; i++) {
                        _cntS = _cntS + parseInt(_data[i].cnt)
                    }
                    _that.NotificationsSpeedCount = _cntS;

                    _that._Post('/api/gn/getnotificationsspeedalarms', { cid: _that.crypt(_that.user.ClientId), rid: _that.crypt(_that.user.RoleId), uid: _that.crypt(_that.user.UserId) }, function (_data) {
                        _that.NotificationsSpeed = _data
                        for (let i = 0; i < _that.NotificationsSpeed.length; i++) {
                            _that.NotificationsSpeed[i].date = moment(_that.NotificationsSpeed[i].datetime).format('DD') + ' ' + _that.dic.l[moment(_that.NotificationsSpeed[i].datetime).format('MMMM')] + ' ' + moment(_that.NotificationsSpeed[i].datetime).format('YYYY');
                            _that.NotificationsSpeed[i].time = moment(_that.NotificationsSpeed[i].datetime).format(_that.user.TFormat);

                            if (_that.NotificationsSpeed[i].name == 'draeger') {
                                _that.NotificationsSpeed[i].date1 = moment(_that.NotificationsSpeed[i].info.split('^^^')[0]).format('DD') + ' ' + _that.dic.l[moment(_that.NotificationsSpeed[i].info.split('^^^')[0]).format('MMMM')] + ' ' + moment(_that.NotificationsSpeed[i].info.split('^^^')[0]).format('YYYY');
                                _that.NotificationsSpeed[i].time1 = moment(_that.NotificationsSpeed[i].info.split('^^^')[0]).format(_that.user.TFormat);

                                _that.NotificationsSpeed[i].avalue = _that.NotificationsSpeed[i].info.split('^^^')[1]
                                _that.NotificationsSpeed[i].avalueDraegerDriver = _that.NotificationsSpeed[i].info.split('^^^')[2]
                            }
                            _that.NotificationsSpeed[i].over = (parseInt(_that.NotificationsSpeed[i].speed) - parseInt(_that.NotificationsSpeed[i].maxspeed)) + ' Km/h'
                        }
                    })
                })
            })
            //realni
            _that._Post('/api/gn/getnotifications', { type: _that.crypt('other'), cid: _that.crypt(_that.user.ClientId), rid: _that.crypt(_that.user.RoleId), uid: _that.crypt(_that.user.UserId) }, function (_data) {
                var _cnt = 0
                for (var i = 0; i < _data.length; i++) {
                    _cnt = _cnt + parseInt(_data[i].cnt)
                }
                _that.NlbOtherNotificationsCount = _cnt

                if (_that.user.driverid + '' == '-1' && _that.NlbOtherNotificationsCount > 0 && _that.NlbOtherNotificationsCount > tmpCntOtherAlarms) {
                    _that.soundPlayer.play();
                }
                var notificationLimit = _that.notificationNlbOtherOffset + 10

                _that._Post('/api/gn/getnotificationsalarms', { type: _that.crypt('other'), cid: _that.crypt(_that.user.ClientId), rid: _that.crypt(_that.user.RoleId), uid: _that.crypt(_that.user.UserId), limit: _that.crypt(notificationLimit), offset: _that.crypt(0) }, function (_data) {
                    _that.NlbOtherNotifications = _data
                    for (let i = 0; i < _that.NlbOtherNotifications.length; i++) {
                        _that.NlbOtherNotifications[i].date = moment(_that.NlbOtherNotifications[i].datetime).format('DD') + ' ' + _that.dic.l[moment(_that.NlbOtherNotifications[i].datetime).format('MMMM')] + ' ' + moment(_that.NlbOtherNotifications[i].datetime).format('YYYY');
                        _that.NlbOtherNotifications[i].time = moment(_that.NlbOtherNotifications[i].datetime).format(_that.user.TFormat);

                        if (_that.NlbOtherNotifications[i].name == 'draeger') {
                            _that.NlbOtherNotifications[i].date1 = moment(_that.NlbOtherNotifications[i].info.split('^^^')[0]).format('DD') + ' ' + _that.dic.l[moment(_that.NlbOtherNotifications[i].info.split('^^^')[0]).format('MMMM')] + ' ' + moment(_that.NlbOtherNotifications[i].info.split('^^^')[0]).format('YYYY');
                            _that.NlbOtherNotifications[i].time1 = moment(_that.NlbOtherNotifications[i].info.split('^^^')[0]).format(_that.user.TFormat);

                            _that.NlbOtherNotifications[i].avalue = _that.NlbOtherNotifications[i].info.split('^^^')[1]
                            _that.NlbOtherNotifications[i].avalueDraegerDriver = _that.NlbOtherNotifications[i].info.split('^^^')[2]
                        }
                    }
                })

                //LIVE SPEED WARNING
                _that._Post('/api/gn/getspeednotifications', { cid: _that.crypt(_that.user.ClientId), rid: _that.crypt(_that.user.RoleId), uid: _that.crypt(_that.user.UserId) }, function (_data) {
                    var _cntS = 0
                    for (var i = 0; i < _data.length; i++) {
                        _cntS = _cntS + parseInt(_data[i].cnt)
                    }
                    _that.NotificationsSpeedCount = _cntS;

                    _that._Post('/api/gn/getnotificationsspeedalarms', { cid: _that.crypt(_that.user.ClientId), rid: _that.crypt(_that.user.RoleId), uid: _that.crypt(_that.user.UserId) }, function (_data) {
                        _that.NotificationsSpeed = _data
                        for (let i = 0; i < _that.NotificationsSpeed.length; i++) {
                            _that.NotificationsSpeed[i].date = moment(_that.NotificationsSpeed[i].datetime).format('DD') + ' ' + _that.dic.l[moment(_that.NotificationsSpeed[i].datetime).format('MMMM')] + ' ' + moment(_that.NotificationsSpeed[i].datetime).format('YYYY');
                            _that.NotificationsSpeed[i].time = moment(_that.NotificationsSpeed[i].datetime).format(_that.user.TFormat);

                            if (_that.NotificationsSpeed[i].name == 'draeger') {
                                _that.NotificationsSpeed[i].date1 = moment(_that.NotificationsSpeed[i].info.split('^^^')[0]).format('DD') + ' ' + _that.dic.l[moment(_that.NotificationsSpeed[i].info.split('^^^')[0]).format('MMMM')] + ' ' + moment(_that.NotificationsSpeed[i].info.split('^^^')[0]).format('YYYY');
                                _that.NotificationsSpeed[i].time1 = moment(_that.NotificationsSpeed[i].info.split('^^^')[0]).format(_that.user.TFormat);

                                _that.NotificationsSpeed[i].avalue = _that.NotificationsSpeed[i].info.split('^^^')[1]
                                _that.NotificationsSpeed[i].avalueDraegerDriver = _that.NotificationsSpeed[i].info.split('^^^')[2]
                            }

                            _that.NotificationsSpeed[i].over = (parseInt(_that.NotificationsSpeed[i].speed) - parseInt(_that.NotificationsSpeed[i].maxspeed)) + ' Km/h'
                        }
                    })
                })
            })
        } else {
            var tmpCntAlarms = _that.NotificationsCount;
            this._Post('/api/gn/getnotifications', { type: this.crypt('all'), cid: this.crypt(this.user.ClientId), rid: this.crypt(this.user.RoleId), uid: this.crypt(this.user.UserId) }, function (_data) {
                // _that.Notifications = _data
                var _cnt = 0
                for (var i = 0; i < _data.length; i++) {
                    _cnt = _cnt + parseInt(_data[i].cnt)
                }
                _that.NotificationsCount = _cnt

                if (_that.user.driverid + '' == '-1' && _that.NotificationsCount > 0 && _that.NotificationsCount > tmpCntAlarms) {
                    _that.soundPlayer.play();
                }
                var notificationLimit = _that.notificationOffset + 10

                _that._Post('/api/gn/getnotificationsalarms', { type: _that.crypt('all'), cid: _that.crypt(_that.user.ClientId), rid: _that.crypt(_that.user.RoleId), uid: _that.crypt(_that.user.UserId), limit: _that.crypt(notificationLimit), offset: _that.crypt(0) }, function (_data) {
                    _that.Notifications = _data
                    for (let i = 0; i < _that.Notifications.length; i++) {
                        _that.Notifications[i].date = moment(_that.Notifications[i].datetime).format('DD') + ' ' + _that.dic.l[moment(_that.Notifications[i].datetime).format('MMMM')] + ' ' + moment(_that.Notifications[i].datetime).format('YYYY');
                        _that.Notifications[i].time = moment(_that.Notifications[i].datetime).format(_that.user.TFormat);

                        if (_that.Notifications[i].name == 'draeger') {
                            _that.Notifications[i].date1 = moment(_that.Notifications[i].info.split('^^^')[0]).format('DD') + ' ' + _that.dic.l[moment(_that.Notifications[i].info.split('^^^')[0]).format('MMMM')] + ' ' + moment(_that.Notifications[i].info.split('^^^')[0]).format('YYYY');
                            _that.Notifications[i].time1 = moment(_that.Notifications[i].info.split('^^^')[0]).format(_that.user.TFormat);

                            _that.Notifications[i].avalue = _that.Notifications[i].info.split('^^^')[1]
                            _that.Notifications[i].avalueDraegerDriver = _that.Notifications[i].info.split('^^^')[2]
                        }

                        if (_that.Notifications[i].name == 'service') {
                            if (_that.Notifications[i].info != undefined) {
                                if (_that.Notifications[i].info.indexOf('days') != -1)
                                    _that.Notifications[i].info = _that.Notifications[i].info.replace("days", _that.dic.l['aserv01'])
                                if (_that.Notifications[i].info.indexOf('Km') != -1)
                                    _that.Notifications[i].info = _that.Notifications[i].info.replace("Km", _that.dic.l['aserv02'])
                            }
                        }
                    }
                })

                //LIVE SPEED WARNING
                _that._Post('/api/gn/getspeednotifications', { cid: _that.crypt(_that.user.ClientId), rid: _that.crypt(_that.user.RoleId), uid: _that.crypt(_that.user.UserId) }, function (_data) {
                    var _cntS = 0
                    for (var i = 0; i < _data.length; i++) {
                        _cntS = _cntS + parseInt(_data[i].cnt)
                    }
                    _that.NotificationsSpeedCount = _cntS;

                    _that._Post('/api/gn/getnotificationsspeedalarms', { cid: _that.crypt(_that.user.ClientId), rid: _that.crypt(_that.user.RoleId), uid: _that.crypt(_that.user.UserId) }, function (_data) {
                        _that.NotificationsSpeed = _data
                        for (let i = 0; i < _that.NotificationsSpeed.length; i++) {
                            _that.NotificationsSpeed[i].date = moment(_that.NotificationsSpeed[i].datetime).format('DD') + ' ' + _that.dic.l[moment(_that.NotificationsSpeed[i].datetime).format('MMMM')] + ' ' + moment(_that.NotificationsSpeed[i].datetime).format('YYYY');
                            _that.NotificationsSpeed[i].time = moment(_that.NotificationsSpeed[i].datetime).format(_that.user.TFormat);

                            if (_that.NotificationsSpeed[i].name == 'draeger') {
                                _that.NotificationsSpeed[i].date1 = moment(_that.NotificationsSpeed[i].info.split('^^^')[0]).format('DD') + ' ' + _that.dic.l[moment(_that.NotificationsSpeed[i].info.split('^^^')[0]).format('MMMM')] + ' ' + moment(_that.NotificationsSpeed[i].info.split('^^^')[0]).format('YYYY');
                                _that.NotificationsSpeed[i].time1 = moment(_that.NotificationsSpeed[i].info.split('^^^')[0]).format(_that.user.TFormat);

                                _that.NotificationsSpeed[i].avalue = _that.NotificationsSpeed[i].info.split('^^^')[1]
                                _that.NotificationsSpeed[i].avalueDraegerDriver = _that.NotificationsSpeed[i].info.split('^^^')[2]
                            }

                            _that.NotificationsSpeed[i].over = (parseInt(_that.NotificationsSpeed[i].speed) - parseInt(_that.NotificationsSpeed[i].maxspeed)) + ' Km/h'
                        }
                    })
                })

            })


        }
    }


    setDateTimeFormat(_dt) {
        return moment(_dt).format(this.user.DFormat + ' ' + this.user.TFormat);
    }
    getReleaseVersion() {
        var _that = this
        _that._Post('/api/gn/getreleaseversion', { uid: _that.crypt(_that.user.UserId), cid: _that.crypt(_that.user.ClientId), lang: _that.crypt(_that.dic.Lang) }, function (_data) {
            _that.ReleaseVersion = _data.rel
            if (_data.u[0] + '' != 'undefined')
                _that.user.lastreleaseversion = _data.u[0].lastreleaseversion
            for (let i = 0; i < _that.ReleaseVersion.length; i++) {
                //_that.ReleaseVersion[i].datetime = moment(_that.ReleaseVersion[i].datetime).format('DD') + ' ' + _that.dic.l[moment(_that.ReleaseVersion[i].datetime).format('MMMM')] + ' ' + moment(_that.ReleaseVersion[i].datetime).format('YYYY'); + ' ' + moment(_that.ReleaseVersion[i].datetime).format(_that.user.TFormat);
                _that.ReleaseVersion[i].datetime = moment(_that.ReleaseVersion[i].datetime).format('DD.MM.YYYY');
            }
        })
    }

    stopIntervalForNotifications() {
        if (this.notifInterval != null) {
            clearInterval(this.notifInterval)
            this.notifInterval = null
        }
    }

    stopIntervalForCheckUser() {
        if (this.checkUserInterval != null) {
            clearInterval(this.checkUserInterval)
            this.checkUserInterval = null
        }
    }

    stopIntervalForRelease() {
        if (this.releaseInterval != null) {
            clearInterval(this.releaseInterval)
            this.releaseInterval = null
        }
    }

    loadWaiting() {
        this.loaderWaiting = this.loadingCtrl.create({
            content: this.dic.l['wait'],
        });
        this.loaderWaiting.present();
    }

    _latcyr(_val) {
        var car;
        car = _val;
        car = car.replace(/H/g, "Х");
        car = car.replace(/A/g, "А");
        car = car.replace(/B/g, "Б");
        car = car.replace(/V/g, "В");
        car = car.replace(/G/g, "Г");
        car = car.replace(/D/g, "Д");
        car = car.replace(/Дz/g, "Џ");
        car = car.replace(/ДZ/g, "Џ");
        car = car.replace(/Дj/g, "Ѓ");
        car = car.replace(/ДJ/g, "Ѓ");
        car = car.replace(/Ǵ/g, "Ѓ");
        car = car.replace(/Ѓ/g, "Ѓ");
        car = car.replace(/Г'/g, "Ѓ");
        car = car.replace(/E/g, "Е");
        car = car.replace(/Ž/g, "Ж");
        car = car.replace(/Z/g, "З");
        car = car.replace(/ЗХ/g, "Ж");
        car = car.replace(/Зh/g, "Ж");
        car = car.replace(/З'/g, "Ж");
        car = car.replace(/ДЗ/g, "Ѕ");
        car = car.replace(/Дz/g, "Ѕ");
        car = car.replace(/I/g, "И");
        car = car.replace(/J/g, "Ј");
        car = car.replace(/K/g, "К");
        car = car.replace(/L/g, "Л");
        car = car.replace(/ЛЈ/g, "Љ");
        car = car.replace(/Лj/g, "Љ");
        car = car.replace(/M/g, "М");
        car = car.replace(/N/g, "Н");
        car = car.replace(/НЈ/g, "Њ");
        car = car.replace(/Нj/g, "Њ");
        car = car.replace(/O/g, "О");
        car = car.replace(/P/g, "П");
        car = car.replace(/R/g, "Р");
        car = car.replace(/S/g, "С");
        car = car.replace(/T/g, "Т");
        car = car.replace(/Кj/g, "Ќ");
        car = car.replace(/КЈ/g, "Ќ");
        car = car.replace(/Ḱ/g, "Ќ");
        car = car.replace(/Ќ/g, "Ќ");
        car = car.replace(/К'/g, "Ќ");
        car = car.replace(/U/g, "У");
        car = car.replace(/F/g, "Ф");
        car = car.replace(/C/g, "Ц");
        car = car.replace(/Č/g, "Ч");
        car = car.replace(/Ц'/g, "Ч");
        car = car.replace(/ЦХ/g, "Ч");
        car = car.replace(/Цh/g, "Ч");
        car = car.replace(/Ѕ'/g, "Џ");
        car = car.replace(/ЅХ/g, "Џ");
        car = car.replace(/Ѕh/g, "Џ");
        car = car.replace(/Š/g, "Ш");
        car = car.replace(/С'/g, "Ш");
        car = car.replace(/СХ/g, "Ш");
        car = car.replace(/Сh/g, "Ш");

        car = car.replace(/Q/g, "Љ");
        car = car.replace(/W/g, "Њ");
        car = car.replace(/Y/g, "S");
        car = car.replace(/\{/g, "Ш");
        car = car.replace(/\}/g, "Ѓ");
        car = car.replace(/\|/g, "Ж");
        car = car.replace(/\"/g, "Ќ");
        car = car.replace(/\:/g, "Ч");

        car = car.replace(/h/g, "х");
        car = car.replace(/a/g, "а");
        car = car.replace(/b/g, "б");
        car = car.replace(/v/g, "в");
        car = car.replace(/g/g, "г");
        car = car.replace(/d/g, "д");
        car = car.replace(/дz/g, "џ");
        car = car.replace(/дj/g, "ѓ");
        car = car.replace(/ǵ/g, "ѓ");
        car = car.replace(/ѓ/g, "ѓ");
        car = car.replace(/г'/g, "ѓ");
        car = car.replace(/e/g, "е");
        car = car.replace(/ž/g, "ж");
        car = car.replace(/z/g, "з");
        car = car.replace(/зх/g, "ж");
        car = car.replace(/з'/g, "ж");
        car = car.replace(/дз/g, "ѕ");
        car = car.replace(/i/g, "и");
        car = car.replace(/j/g, "ј");
        car = car.replace(/k/g, "к");
        car = car.replace(/l/g, "л");
        car = car.replace(/лј/g, "љ");
        car = car.replace(/m/g, "м");
        car = car.replace(/n/g, "н");
        car = car.replace(/нј/g, "њ");
        car = car.replace(/o/g, "о");
        car = car.replace(/p/g, "п");
        car = car.replace(/r/g, "р");
        car = car.replace(/s/g, "с");
        car = car.replace(/t/g, "т");
        car = car.replace(/ḱ/g, "ќ");
        car = car.replace(/ќ/g, "ќ");
        car = car.replace(/к'/g, "ќ");
        car = car.replace(/кј/g, "ќ");
        car = car.replace(/u/g, "у");
        car = car.replace(/f/g, "ф");
        car = car.replace(/c/g, "ц");
        car = car.replace(/č/g, "ч");
        car = car.replace(/ц'/g, "ч");
        car = car.replace(/цх/g, "ч");
        car = car.replace(/ѕ'/g, "џ");
        car = car.replace(/ѕх/g, "џ");
        car = car.replace(/š/g, "ш");
        car = car.replace(/с'/g, "ш");
        car = car.replace(/сх/g, "ш");
        car = car.replace(/è/g, "ѐ");
        car = car.replace(/ì/g, "ѝ");
        car = car.replace(/е'/g, "ѐ");
        car = car.replace(/и'/g, "ѝ");

        car = car.replace(/q/g, "љ");
        car = car.replace(/w/g, "њ");
        car = car.replace(/y/g, "ѕ");
        car = car.replace(/\[/g, "ш");
        car = car.replace(/\]/g, "ѓ");
        car = car.replace(/\\/g, "ж");
        car = car.replace(/\'/g, "ќ");
        car = car.replace(/\;/g, "ч");
        return car;
    }
    _cyrlat(_val) {
        var car;
        car = _val;
        car = car.replace(/ѐ/g, "e");
        car = car.replace(/ѝ/g, "i");
        car = car.replace(/а/g, "a");
        car = car.replace(/б/g, "b");
        car = car.replace(/в/g, "v");
        car = car.replace(/г/g, "g");
        car = car.replace(/д/g, "d");
        car = car.replace(/ѓ/g, "g");
        car = car.replace(/е/g, "e");
        car = car.replace(/ж/g, "z");
        car = car.replace(/з/g, "z");
        car = car.replace(/ѕ/g, "dz");
        car = car.replace(/и/g, "i");
        car = car.replace(/ј/g, "j");
        car = car.replace(/к/g, "k");
        car = car.replace(/л/g, "l");
        car = car.replace(/љ/g, "lj");
        car = car.replace(/м/g, "m");
        car = car.replace(/н/g, "n");
        car = car.replace(/њ/g, "nj");
        car = car.replace(/о/g, "o");
        car = car.replace(/п/g, "p");
        car = car.replace(/р/g, "r");
        car = car.replace(/с/g, "s");
        car = car.replace(/т/g, "t");
        car = car.replace(/ќ/g, "k");
        car = car.replace(/у/g, "u");
        car = car.replace(/ф/g, "f");
        car = car.replace(/х/g, "h");
        car = car.replace(/ц/g, "c");
        car = car.replace(/ч/g, "c");
        car = car.replace(/џ/g, "dz");
        car = car.replace(/ш/g, "s");
        car = car.replace(/А/g, "A");
        car = car.replace(/Б/g, "B");
        car = car.replace(/В/g, "V");
        car = car.replace(/Г/g, "G");
        car = car.replace(/Д/g, "D");
        car = car.replace(/Ѓ/g, "G");
        car = car.replace(/Е/g, "E");
        car = car.replace(/Ж/g, "Z");
        car = car.replace(/З/g, "Z");
        car = car.replace(/Ѕ/g, "Dz")
        car = car.replace(/И/g, "I");
        car = car.replace(/Ј/g, "J");
        car = car.replace(/К/g, "K");
        car = car.replace(/Л/g, "L");
        car = car.replace(/Љ/g, "Lj");
        car = car.replace(/М/g, "M");
        car = car.replace(/Н/g, "N");
        car = car.replace(/Њ/g, "Nj");
        car = car.replace(/О/g, "O");
        car = car.replace(/П/g, "P");
        car = car.replace(/Р/g, "R");
        car = car.replace(/С/g, "S");
        car = car.replace(/Т/g, "T");
        car = car.replace(/Ќ/g, "K");
        car = car.replace(/У/g, "U");
        car = car.replace(/Ф/g, "F");
        car = car.replace(/Х/g, "H");
        car = car.replace(/Ц/g, "C");
        car = car.replace(/Ч/g, "C");
        car = car.replace(/Џ/g, "DZ");
        car = car.replace(/Ш/g, "S");
        return car;
    }

    getPriv(key) {
        if (this.priv.length == 0)
            return true;
        var num;
        for (var i = 0; i < this.priv.length; i++) {
            if (this.user.RoleId == 3) {
                if (this.user.UserId == this.priv[i].userid) {
                    return this.priv[i][key];
                }
            } else {
                return true;
            }
        }
    }

    getOnlyActReportByUid(key) {
        if (this.onlyactreportbyuid.length == 0)
            return false;
        for (var i = 0; i < this.onlyactreportbyuid.length; i++) {
            if (this.user.UserId == this.onlyactreportbyuid[i].userid) {
                return this.onlyactreportbyuid[i][key] + '' == '1' ? true : false;
            }
        }
    }

    refreshOnlyActByUid(_uid) {
        var _that = this
        this._Post('/api/gn/reports/refreshonlyactbyuid', { uid: this.crypt(_uid) }, function (_data) {
            _that.onlyactreportbyuid = _data.actbyuid
        })
    }

    disableBtn() {
        let loading = this.loadingCtrl.create({
            content: '',
            spinner: 'hide',
            cssClass: "my-loading"
        });
        loading.present();
        this.loading = loading;
        // setTimeout(() => {
        //     loading.dismiss();
        // }, 2000);
    }

    enableBtn() {
        this.loading.dismiss();
    }



    makeTextFile = function (text) {
        var data = new Blob([text], { type: 'text/plain' });
        if (this.textFile !== null) {
            window.URL.revokeObjectURL(this.textFile);
        }
        this.textFile = window.URL.createObjectURL(data);
        return this.textFile;
    };

    //   createTxt() {
    //     var inputValue = 'test text';
    //     (<HTMLElement>document.getElementById('downloadlink')).setAttribute('href', this.makeTextFile(inputValue));
    //   }

    prepareTXT(_content, _name) {
        (<HTMLElement>document.getElementById('downloadTxtLink')).setAttribute('download', _name + '.txt');
        (<HTMLElement>document.getElementById('downloadTxtLink')).setAttribute('href', this.makeTextFile(_content));
    }

    //*********** PREPARE XLS ***************/
    prepareXLS(_objArr, _name, _sendViaEmail = false) {
        var workbook = new Excel.Workbook();
        workbook.creator = 'Geonet GPS';
        workbook.lastModifiedBy = 'Geonet GPS';
        workbook.created = new Date();
        workbook.modified = new Date();
        workbook.lastPrinted = new Date();



        workbook.properties.date1904 = true;
        for (var r = 0; r < _objArr.Sheets.length; r++) {
            var _obj = _objArr.Sheets[r]
            var _ColLetters = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z', 'AA', 'AB', 'AC', 'AD', 'AE', 'AF', 'AG', 'AH', 'AI', 'AJ', 'AK', 'AL', 'AM', 'AN', 'AO', 'AP', 'AQ', 'AR', 'AS', 'AT', 'AU', 'AV', 'AW', 'AX', 'AY', 'AZ', 'BA', 'BB', 'BC', 'BD', 'BE', 'BF', 'BG', 'BH', 'BI', 'BJ', 'BK', 'BL', 'BM', 'BN', 'BO', 'BP', 'BQ', 'BR', 'BS', 'BT', 'BU', 'BV', 'BW', 'BX', 'BY', 'BZ', 'CA', 'CB', 'CC', 'CD', 'CE', 'CF', 'CG', 'CH', 'CI', 'CJ', 'CK', 'CL', 'CM', 'CN', 'CO', 'CP', 'CQ', 'CR', 'CS', 'CT', 'CU', 'CV', 'CW', 'CX', 'CY', 'CZ', 'DA', 'DB', 'DC', 'DD', 'DE', 'DF', 'DG', 'DH', 'DI', 'DJ', 'DK', 'DL', 'DM', 'DN', 'DO', 'DP', 'DQ', 'DR', 'DS', 'DT', 'DU', 'DV', 'DW', 'DX', 'DY', 'DZ', 'EA', 'EB', 'EC', 'ED', 'EE', 'EF', 'EG', 'EH', 'EI', 'EJ', 'EK', 'EL', 'EM', 'EN', 'EO', 'EP', 'EQ', 'ER', 'ES', 'ET', 'EU', 'EV', 'EW', 'EX', 'EY', 'EZ', 'FA', 'FB', 'FC', 'FD', 'FE', 'FF', 'FG', 'FH', 'FI', 'FJ', 'FK', 'FL', 'FM', 'FN', 'FO', 'FP', 'FQ', 'FR', 'FS', 'FT', 'FU', 'FV', 'FW', 'FX', 'FY', 'FZ', 'GA', 'GB', 'GC', 'GD', 'GE', 'GF', 'GG', 'GH', 'GI', 'GJ', 'GK', 'GL', 'GM', 'GN', 'GO', 'GP', 'GQ', 'GR', 'GS', 'GT', 'GU', 'GV', 'GW', 'GX', 'GY', 'GZ', 'HA', 'HB', 'HC', 'HD', 'HE', 'HF', 'HG', 'HH', 'HI', 'HJ', 'HK', 'HL', 'HM', 'HN', 'HO', 'HP', 'HQ', 'HR', 'HS', 'HT', 'HU', 'HV', 'HW', 'HX', 'HY', 'HZ', 'IA', 'IB', 'IC', 'ID', 'IE', 'IF', 'IG', 'IH', 'II', 'IJ', 'IK', 'IL', 'IM', 'IN', 'IO', 'IP', 'IQ', 'IR', 'IS', 'IT', 'IU', 'IV', 'IW', 'IX', 'IY', 'IZ', 'JA', 'JB', 'JC', 'JD', 'JE', 'JF', 'JG', 'JH', 'JI', 'JJ', 'JK', 'JL', 'JM', 'JN', 'JO', 'JP', 'JQ', 'JR', 'JS', 'JT', 'JU', 'JV', 'JW', 'JX', 'JY', 'JZ', 'KA', 'KB', 'KC', 'KD', 'KE', 'KF', 'KG', 'KH', 'KI', 'KJ', 'KK', 'KL', 'KM', 'KN', 'KO', 'KP', 'KQ', 'KR', 'KS', 'KT', 'KU', 'KV', 'KW', 'KX', 'KY', 'KZ', 'LA', 'LB', 'LC', 'LD', 'LE', 'LF', 'LG', 'LH', 'LI', 'LJ', 'LK', 'LL', 'LM', 'LN', 'LO', 'LP', 'LQ', 'LR', 'LS', 'LT', 'LU', 'LV', 'LW', 'LX', 'LY', 'LZ', 'MA', 'MB', 'MC', 'MD', 'ME', 'MF', 'MG', 'MH', 'MI', 'MJ', 'MK', 'ML', 'MM', 'MN', 'MO', 'MP', 'MQ', 'MR', 'MS', 'MT', 'MU', 'MV', 'MW', 'MX', 'MY', 'MZ', 'NA', 'NB', 'NC', 'ND', 'NE', 'NF', 'NG', 'NH', 'NI', 'NJ', 'NK', 'NL', 'NM', 'NN', 'NO', 'NP', 'NQ', 'NR', 'NS', 'NT', 'NU', 'NV', 'NW', 'NX', 'NY', 'NZ', 'OA', 'OB', 'OC', 'OD', 'OE', 'OF', 'OG', 'OH', 'OI', 'OJ', 'OK', 'OL', 'OM', 'ON', 'OO', 'OP', 'OQ', 'OR', 'OS', 'OT', 'OU', 'OV', 'OW', 'OX', 'OY', 'OZ', 'PA', 'PB', 'PC', 'PD', 'PE', 'PF', 'PG', 'PH', 'PI', 'PJ', 'PK', 'PL', 'PM', 'PN', 'PO', 'PP', 'PQ', 'PR', 'PS', 'PT', 'PU', 'PV', 'PW', 'PX', 'PY', 'PZ', 'QA', 'QB', 'QC', 'QD', 'QE', 'QF', 'QG', 'QH', 'QI', 'QJ', 'QK', 'QL', 'QM', 'QN', 'QO', 'QP', 'QQ', 'QR', 'QS', 'QT', 'QU', 'QV', 'QW', 'QX', 'QY', 'QZ', 'RA', 'RB', 'RC', 'RD', 'RE', 'RF', 'RG', 'RH', 'RI', 'RJ', 'RK', 'RL', 'RM', 'RN', 'RO', 'RP', 'RQ', 'RR', 'RS', 'RT', 'RU', 'RV', 'RW', 'RX', 'RY', 'RZ', 'SA', 'SB', 'SC', 'SD', 'SE', 'SF', 'SG', 'SH', 'SI', 'SJ', 'SK', 'SL', 'SM', 'SN', 'SO', 'SP', 'SQ', 'SR', 'SS', 'ST', 'SU', 'SV', 'SW', 'SX', 'SY', 'SZ', 'TA', 'TB', 'TC', 'TD', 'TE', 'TF', 'TG', 'TH', 'TI', 'TJ', 'TK', 'TL', 'TM', 'TN', 'TO', 'TP', 'TQ', 'TR', 'TS', 'TT', 'TU', 'TV', 'TW', 'TX', 'TY', 'TZ', 'UA', 'UB', 'UC', 'UD', 'UE', 'UF', 'UG', 'UH', 'UI', 'UJ', 'UK', 'UL', 'UM', 'UN', 'UO', 'UP', 'UQ', 'UR', 'US', 'UT', 'UU', 'UV', 'UW', 'UX', 'UY', 'UZ', 'VA', 'VB', 'VC', 'VD', 'VE', 'VF', 'VG', 'VH', 'VI', 'VJ', 'VK', 'VL', 'VM', 'VN', 'VO', 'VP', 'VQ', 'VR', 'VS', 'VT', 'VU', 'VV', 'VW', 'VX', 'VY', 'VZ', 'WA', 'WB', 'WC', 'WD', 'WE', 'WF', 'WG', 'WH', 'WI', 'WJ', 'WK', 'WL', 'WM', 'WN', 'WO', 'WP', 'WQ', 'WR', 'WS', 'WT', 'WU', 'WV', 'WW', 'WX', 'WY', 'WZ', 'XA', 'XB', 'XC', 'XD', 'XE', 'XF', 'XG', 'XH', 'XI', 'XJ', 'XK', 'XL', 'XM', 'XN', 'XO', 'XP', 'XQ', 'XR', 'XS', 'XT', 'XU', 'XV', 'XW', 'XX', 'XY', 'XZ', 'YA', 'YB', 'YC', 'YD', 'YE', 'YF', 'YG', 'YH', 'YI', 'YJ', 'YK', 'YL', 'YM', 'YN', 'YO', 'YP', 'YQ', 'YR', 'YS', 'YT', 'YU', 'YV', 'YW', 'YX', 'YY', 'YZ', 'ZA', 'ZB', 'ZC', 'ZD', 'ZE', 'ZF', 'ZG', 'ZH', 'ZI', 'ZJ', 'ZK', 'ZL', 'ZM', 'ZN', 'ZO', 'ZP', 'ZQ', 'ZR', 'ZS', 'ZT', 'ZU', 'ZV', 'ZW', 'ZX', 'ZY', 'ZZ']
            var _RowIdx = 2
            var _ColIdx = 1



            var worksheet = workbook.addWorksheet(_obj.Title);

            var colSpan = 0
            var wscolsIdx = -1
            for (var i = 0; i < _obj.tables.length; i++) {
                colSpan = colSpan + _obj.tables[i].Cols.length
                for (var j = 0; j < _obj.tables[i].Cols.length; j++) {
                    if (j > wscolsIdx) {
                        wscolsIdx = j
                    }
                }
            }


            //Document Title
            var cell1 = worksheet.getCell(_ColLetters[_ColIdx] + _RowIdx);
            cell1.value = _obj.Title
            //worksheet.mergeCells(_ColLetters[_ColIdx] + _RowIdx + ':' + (_ColLetters[_ColIdx + colSpan] + _RowIdx));
            cell1.style = { font: { bold: true, size: 16 }, alignment: { horizontal: 'left' }, color: { argb: 'FF5C93C4' } }
            _RowIdx = _RowIdx + 1

            //Document Subtitle(s)
            if (_obj.SubTitle != '') {
                var cell2 = worksheet.getCell(_ColLetters[_ColIdx] + _RowIdx);
                cell2.value = _obj.SubTitle
                //worksheet.mergeCells(_ColLetters[_ColIdx] + _RowIdx + ':' + (_ColLetters[_ColIdx + colSpan] + _RowIdx));
                cell2.style = { font: { bold: false, size: 12 }, alignment: { horizontal: 'left' }, color: { argb: 'FF5C93C4' } }
                _RowIdx = _RowIdx + 1
            } else {
                for (j = 0; j < _obj.SubTitles.length; j++) {
                    var cell2 = worksheet.getCell(_ColLetters[_ColIdx] + _RowIdx);
                    cell2.value = _obj.SubTitles[j]
                    cell2.style = { font: { bold: false, size: 12 }, alignment: { horizontal: 'left' }, color: { argb: 'FF5C93C4' } }
                    _RowIdx = _RowIdx + 1
                }
            }




            for (var i = 0; i < _obj.tables.length; i++) {
                _RowIdx = _RowIdx + 1

                var t = _obj.tables[i]
                var cell2 = worksheet.getCell(_ColLetters[_ColIdx] + _RowIdx);
                cell2.value = t.Title
                worksheet.mergeCells(_ColLetters[_ColIdx] + _RowIdx + ':' + (_ColLetters[_ColIdx + t.Cols.length - 1] + _RowIdx));
                cell2.style = { font: { bold: true, size: 12, color: { argb: 'FFFFFFFF' } }, alignment: { horizontal: 'center' } }
                cell2.fill = { type: 'pattern', pattern: 'darkTrellis', bgColor: { argb: 'FF5C93C4' } }
                _RowIdx = _RowIdx + 1

                //Col titles
                var c = _ColIdx
                for (var j = 0; j < t.Cols.length; j++) {
                    var cell3 = worksheet.getCell(_ColLetters[c] + _RowIdx);
                    cell3.value = t.Cols[j].text

                    var col3 = worksheet.getColumn(c + 1);
                    col3.width = t.Cols[j].width

                    cell3.style = { font: { bold: true, size: 12, color: { argb: 'FFFFFFFF' } }, alignment: { horizontal: t.Cols[j].align } }
                    cell3.fill = { type: 'pattern', pattern: 'darkTrellis', bgColor: { argb: 'FF71B5F2' } }
                    c = c + 1
                }
                _RowIdx = _RowIdx + 1



                for (var j = 0; j < t.Data.length; j++) {
                    var cc = _ColIdx
                    for (var z = 0; z < t.Data[j].length; z++) {
                        var cell4 = worksheet.getCell(_ColLetters[cc] + _RowIdx);
                        cell4.value = t.Data[j][z]
                        cell4.style = { font: { bold: false, size: 12 }, alignment: { horizontal: t.Cols[z].align } }
                        cc = cc + 1
                    }
                    _RowIdx = _RowIdx + 1
                }

            }
        }

        var _that = this
        // var wbout = workbook.xlsx.write({bookType:'xlsx', bookSST:true, type: 'binary'});
        // postMessage({t:"data", d:wbout});

        workbook.xlsx.writeBuffer().then(data => {
            // console.log(wbout)
            var _dataStr = JSON.stringify(data)

            var blob = new Blob([data], { type: 'application/octet-stream' });
            if (_that.xlsFunctionToServer == true) {
                _that._Post('/api/gn/sendreportviaemailXLS', { name: _that.crypt(_name), eml: _that.crypt('goran@gps.mk'), data: _that.crypt(_dataStr) }, function (_data2) {
                    // console.log(_data2)
                    if (_that.xlsFunctionCallback != null) {
                        _that.xlsFunctionCallback(_data2.xlsname)
                    }
                })
            } else {
                // var blob = new Blob([data], { type: 'application/octet-stream' });
                saveAs(blob, _name + ".xlsx");
            }
        });


    }

    public tByte(bytes: any) {
        bytes = parseInt(bytes)
        var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
        if (bytes == 0) return '0 Byte';
        var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)) + '');
        return Math.round(bytes / Math.pow(1024, i)) + ' ' + sizes[i];
    };
    toBase64(str) {
        return window.btoa(decodeURIComponent(encodeURIComponent(str)));
    }

    public _PostUploadFile(_url: any, _data: any, _callback: any) {
        let headers: any = new Headers();
        // headers.append('Content-Type', 'multipart/form-data;boundary='+Math.random());
        // headers.append('Accept', 'application/json');
        headers.append('Content-Type', 'multipart/form-data');
        headers.append('Accept', 'application/json');
        let options = new RequestOptions({ headers: headers });

        this.httpWeb.post(_url, _data, options).subscribe(function (data: any) {
            var _data = JSON.parse(data._body)
            if (_callback != null) {
                _callback(_data)
            }
        }, function (err) {
            // console.log(err)
        });

    }

    getFileReader(): FileReader {
        const fileReader = new FileReader();
        const zoneOriginalInstance = (fileReader as any)["__zone_symbol__originalInstance"];
        return zoneOriginalInstance || fileReader;
    }


    resetallpinusers() {
        var _that = this
        this._Post('/api/gn/getAllUsersPinIndoor', { cid: this.crypt(_that.user.ClientId) }, function (_data) {
            _that.allpinusers = _data
            _that.allpinusers2 = _data
        })
    }

    resetallprocess() {
        var _that = this
        this._Post('/api/gn/getAllProcessIndoor', { cid: this.crypt(this.user.ClientId) }, function (_data) {
            _that.allprocess = _data
            _that.allprocess2 = _data
        })
    }

    resetallarticles() {
        var _that = this
        this._Post('/api/gn/getAllArticlesIndoor', { cid: this.crypt(this.user.ClientId) }, function (_data) {
            _that.allarticles = _data
            _that.allarticles2 = _data
        })
    }

    reloadWorkOrders(_type) {
        var _that = this
        this._Post('/api/gn/getPinLiveWorkOrders', { pinid: this.crypt(this.pin.pinid), type: this.crypt(_type), userid: this.crypt(this.user.UserId) }, function (_dataD) {
            for (let i = 0; i < _dataD.length; i++) {
                _dataD[i].dt = moment(_dataD[i].dt).format(_that.user.DFormat) + ' ' + moment(_dataD[i].dt).format(_that.user.TFormat)
                _dataD[i].Visible = true
                _dataD[i].incoming = '1'
                _dataD[i].assignrfid = '1'
                //???? _hasOpenedWithoutPauseOrder i _hasOpenedOrder da se cuvaat vo gn ?
                // if (_data[i].isopened == '1' && _data[i].onpause1 == 0) _that._hasOpenedWithoutPauseOrder = true;
                // if (_data[i].isopened == '1') _that._hasOpenedOrder = true;
            }
            _that.workoders = _dataD
        })
    }

    do_logout() {
        this.logout = true;
    }
}



// WEBPACK FOOTER //
// ./src/gn.ts